import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Radio } from 'components/RadioGroup'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { EmojiMap } from 'components/ContentStrategyTypeEmoji/ContentStrategyTypeEmoji'
import { StrategyValuesMobile } from './StrategyValuesMobile'
import { StrategyValuesMobileV2 } from './StrategyValuesMobileV2'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export interface StrategyMobileProps {
  strategy: StrategyType
  onSelect: (strategyId: string) => void
}

export const StrategyMobile = ({ strategy, onSelect }: StrategyMobileProps) => {
  const isNewPostContentTypesEnabled = useFlipperFlag('post_content_types')

  return (
    <div
      className={cx(Styles.strategyContainer, {
        [Styles.isSelected]: strategy.isSelected,
      })}
      onClick={() => {
        if (!strategy.isSelected) {
          onSelect(strategy.id)
        }
      }}
    >
      <div className={Styles.radioWrapper} data-testid="strategy-radio-wrapper">
        <Radio value={strategy.id} size={24} hideRadio aria-label={strategy.name} className={Styles.radio}>
          {({ isSelected, isFocusVisible }) => (
            <RadioBullet isSelected={isSelected} isFocusVisible={isFocusVisible} size={24} />
          )}
        </Radio>
      </div>
      <div className={Styles.strategyContent}>
        <div className={Styles.strategyHeader}>
          <Heading level={5}>
            {EmojiMap[strategy.id]} {strategy.name}
          </Heading>
          <Text variant="metadata" color="var(--dark-60)">
            {strategy.description}
          </Text>
        </div>
        {strategy.isSelected && (
          <>
            {isNewPostContentTypesEnabled ? (
              <StrategyValuesMobileV2 strategy={strategy} />
            ) : (
              <>
                <Text variant="label" color="var(--dark-40)">
                  Content per week
                </Text>
                <StrategyValuesMobile strategy={strategy} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}
